module.exports = __webpack_public_path__ + "img/3화_8(2).76da5837.png";